import {
    BarcodeIcon,
    BinaryIcon,
    CheckboxIcon,
    DateIcon,
    DiskIcon,
    FileIcon,
    FileStackIcon,
    GlobeIcon,
    HandshakeIcon,
    KeyAltIcon,
    ListIcon,
    PersonIcon,
    RadioIcon,
    RubIcon,
    SaveIcon,
    ScanEyeIcon,
    ShoppingBagIcon,
    SquareArrowIcon,
    TableIcon,
    TextAltIcon,
    TextIcon,
    TrackerIcon,
    YandexIcon
} from "shared";
import { ComponentTypes } from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../i18n";

export type IComponentsConfig = Record<ComponentTypes, IComponentConfig>

export interface IComponentConfig {
    icon: React.ReactNode,
    label: string,
    subLabel: string
}

export function useComponentsConfig(): IComponentsConfig {
    const t = useComponentsTranslations();

    const componentsConfig = {
        [ComponentTypes.text]: {
            icon: <TextAltIcon/>,
            label: t("textLabel"),
            subLabel: t("textSubLabel")
        },
        [ComponentTypes.input]: {
            icon: <TextIcon/>,
            label: t("inputLabel"),
            subLabel: t("inputSubLabel")
        },
        [ComponentTypes.multiline]: {
            icon: <TextIcon/>,
            label: t("multilineLabel"),
            subLabel: t("multilineSubLabel")
        },
        [ComponentTypes.dateInput]: {
            icon: <DateIcon/>,
            label: t("dateLabel"),
            subLabel: t("dateSubLabel")
        },
        [ComponentTypes.select]: {
            icon: <ListIcon/>,
            label: t("selectLabel"),
            subLabel: t("selectSubLabel")
        },
        [ComponentTypes.inputWithSelect]: {
            icon: <ListIcon/>,
            label: t("inputWithSelectLabel"),
            subLabel: t("inputWithSelectSubLabel")
        },
        [ComponentTypes.money]: {
            icon: <RubIcon/>,
            label: t("moneyLabel"),
            subLabel: t("moneySubLabel")
        },
        [ComponentTypes.checkbox]: {
            icon: <CheckboxIcon/>,
            label: t("checkboxLabel"),
            subLabel: t("checkboxSubLabel")
        },
        [ComponentTypes.radio]: {
            icon: <RadioIcon/>,
            label: t("radioLabel"),
            subLabel: t("radioSubLabel")
        },
        [ComponentTypes.table]: {
            icon: <TableIcon/>,
            label: t("tableLabel"),
            subLabel: t("tableSubLabel")
        },
        [ComponentTypes.file]: {
            icon: <FileIcon/>,
            label: t("fileLabel"),
            subLabel: t("fileSubLabel")
        },
        [ComponentTypes.hrPerson]: {
            icon: <PersonIcon/>,
            label: t("employeeLabel"),
            subLabel: t("employeeSubLabel")
        },
        [ComponentTypes.yandex]: {
            icon: <YandexIcon/>,
            label: t("yandexLabel"),
            subLabel: t("yandexSubLabel")
        },
        [ComponentTypes.legalYandex]: {
            icon: <YandexIcon/>,
            label: t("legalYandexLabel"),
            subLabel: t("legalYandexSubLabel")
        },
        [ComponentTypes.counterparty]: {
            icon: <HandshakeIcon/>,
            label: t("counterpartyLabel"),
            subLabel: t("counterpartySubLabel")
        },
        [ComponentTypes.saveAndTicket]: {
            icon: <SaveIcon/>,
            label: t("saveAndTicketLabel"),
            subLabel: t("saveAndTicketSubLabel")
        },
        [ComponentTypes.saveToExistingTicket]: {
            icon: <SaveIcon/>,
            label: t("saveToExistingTicketLabel"),
            subLabel: t("saveToExistingTicketSubLabel")
        },
        [ComponentTypes.pdfPassword]: {
            icon: <KeyAltIcon/>,
            label: t("pdfPasswordLabel"),
            subLabel: t("pdfPasswordSubLabel")
        },
        [ComponentTypes.trackerIntegration]: {
            icon: <TrackerIcon/>,
            label: t("trackerIntegrationLabel"),
            subLabel: t("trackerIntegrationSubLabel")
        },
        [ComponentTypes.iprocIntegration]: {
            icon: <ShoppingBagIcon/>,
            label: t("iprocIntegrationLabel"),
            subLabel: t("iprocIntegrationSubLabel")
        },
        [ComponentTypes.externalForm]: {
            icon: <SquareArrowIcon/>,
            label: t("externalFormLabel"),
            subLabel: t("externalFormSubLabel")
        },
        [ComponentTypes.language]: {
            icon: <GlobeIcon/>,
            label: t("languageLabel"),
            subLabel: t("languageSubLabel")
        },
        [ComponentTypes.uuid]: {
            icon: <BinaryIcon/>,
            label: t("uuidLabel"),
            subLabel: t("uuidSubLabel")
        },
        [ComponentTypes.barcode]: {
            icon: <BarcodeIcon/>,
            label: t("barcodeLabel"),
            subLabel: t("barcodeSubLabel")
        },
        [ComponentTypes.autonumber]: {
            icon: <BinaryIcon/>,
            label: t("autonumber.label"),
            subLabel: t("autonumber.subLabel")
        },
        [ComponentTypes.preview]: {
            icon: <ScanEyeIcon/>,
            label: t("previewLabel"),
            subLabel: t("previewSubLabel")
        },
        [ComponentTypes.massDocGeneration]: {
            icon: <FileStackIcon/>,
            label: t("massDocGenerationLabel"),
            subLabel: t("massDocGenerationSubLabel")
        }
    }

    return componentsConfig
}
